/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmModelsListEffectivePrices } from "../../funcs/llmModelsListEffectivePrices.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListEffectivePricesRequest$inboundSchema,
};

export const tool$llmModelsListEffectivePrices: ToolDefinition<typeof args> = {
  name: "llm-models-list-effective-prices",
  description: `List effective prices for the caller's models

For every active model, returns its registry-aware price: an org row, a cluster default for cluster lineage, or unpriced ($0).`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmModelsListEffectivePrices(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
